import React, { useState, useEffect } from 'react';


import { 
    DashboardLayout, Button, Spinner,
    CustomEmailInput, FormInput_text, Dropdown, CustomPasswordInput
} from "components";

import { func_validation } from "functions";
import { useErrorHandling, useSubmission, useUserGroup } from "./hooks";

import ic_small_add from "assets/images/ic_small_add.svg";
import ic_small_save from "assets/images/ic_small_save.svg";

import "assets/scss/billingPortal/modules/userManagement/userUpdate.scss";



export default function UserUpdatePresentation(props) {    
    // Props  
    const { 
        isEditing,
        addUser_requesting, updateUser_requesting,
    } = props;

    // Validate Props
    let isLoading = addUser_requesting || updateUser_requesting;
    
    // States

    const [email, setEmail] = useState("");
    const [isEmailValid, setEmailValidity] = useState();
    const [fullName, setFullName] = useState();
    const [password, setPassword] = useState("");
    const [role, setRole] = useState();
    const [referenceCode, setReferenceCode] = useState();


    // User Group
    const {
        selectedUserGroups,
        userGroupDisplay
    } = useUserGroup({
        ...props
    });
    
    // Submission
    const {
        handleSubmission,
        isFormSubmissionAttempted
    } = useSubmission({
        ...props,
        email, isEmailValid,
        fullName, password,
        role, referenceCode,

        selectedUserGroups
    });
    
    // Error Messages
    const { 
        alertDisplay,
    } = useErrorHandling({ ...props, isFormSubmissionAttempted });

    // Page Details
    let pageHeaderTitle = "Add New User";
    let submitIcon = ic_small_add;
    let submitText = "Add";
    let submitAltText = "Add Icon";

    if (isEditing) {
        pageHeaderTitle = "Edit User";
        submitIcon = ic_small_save;
        submitText = "Save";
        submitAltText = "Save Icon";
    }

    return (
        <DashboardLayout
            headerTitle={pageHeaderTitle}
            isHeaderCloseIconVisible

            updateParentState_visiblity={props.updateParentState_visiblity}

            bodyClassName={"userUpdate"}
            body={(
                <React.Fragment>
                    <div className="userUpdate-subHeader d-flex justify-content-between">
                        {/* Title */}
                        <span className={"userUpdate-subHeader-title"}>Insert Info</span>

                        {/* Action */}
                        <Button
                            className={"userUpdate-subHeader-action"}
                            handleOnClick={handleSubmission}
                            isDecoration_transparentDarkGreyBorder
                        >
                            <div className={"d-flex flex-column align-items-center justify-content-center"}>
                                {isLoading? (
                                    <Spinner size={0} isLeftMarginOptional />
                                ):(
                                    <img
                                        src={submitIcon}
                                        alt={submitAltText}
                                        className={"userUpdate-subHeaderAction-icon"}
                                    />
                                )}
                                <div className={"userUpdate-subHeaderAction-text"}>
                                    {submitText}
                                </div>
                            </div>
                        </Button>
                    </div>

                    <div className="userUpdate-inputWrapper ">
                        {/* Alert Error Messages */}
                        {alertDisplay}
                        
                        <div className="userUpdate-inputWrapper-userInfo d-flex">
                            {/* Username */}
                            <CustomEmailInput
                                className={"userUpdate-inputWrapper-email"}

                                label={"Username"}

                                email={email}
                                handleValueChange={setEmail}
                                isEmailValid={isEmailValid}
                                handleEmailValidity={setEmailValidity}

                                isFormSubmissionAttempted={isFormSubmissionAttempted}

                                handleOnEnterPressed={handleSubmission}

                                options={{
                                    isLabelOptional: false,
                                    isInputOptional: false,
                                    isMarginBtmOptional: true,
                                }}
                            />
                                    
                            {/* Full Name */}
                            <FormInput_text  
                                inputLabel={"Full Name"}

                                className={"userUpdate-inputWrapper-fullName"}
                                inputValue_default={fullName} 

                                isInputBlurHandlingRequired
                                handleInputBlurExtend={(value) => { setFullName(value); }}

                                inputMaxLength={200}

                                customErrorMsgDefault={"Required"}
                                isFormSubmissionAttempted={isFormSubmissionAttempted} 

                                isMarginBtmOptional
                            />

                            {/* Password */}
                            <CustomPasswordInput
                                customInputClassName={"userUpdate-inputWrapper-passwordInput"}

                                label={"Password"}

                                password={password}
                                isFormSubmissionAttempted={isFormSubmissionAttempted}

                                handleValueChange={setPassword}

                                options={{
                                    isLabelOptional: false,
                                    isInputOptional: false,
                                    isMarginBtmOptional: true,
                                }}
                            />

                            {/* Role */}
                            <Dropdown
                                className={"userUpdate-inputWrapper-role"}
                                label={"Role"}
                                isInputRequired
                
                                selectedValueClassName={"userUpdate-inputWrapper-role-input"}
                
                                options={[
                                    {
                                        label: "Internal",
                                        value: "Internal",
                                        groupName: "roleGroupName",
                                    },
                                    {
                                        label: "Dealer",
                                        value: "Dealer",
                                        groupName: "roleGroupName",
                                    },
                                    {
                                        label: "Sales Person",
                                        value: "Sales Person",
                                        groupName: "roleGroupName",
                                    }
                                ]}
                                isOptionRadio

                                selectedValue_default={role}
                                onChange={setRole}
                
                                errorMsg={"Required"}
                                isFormSubmissionAttempted={isFormSubmissionAttempted}

                                isSearchable
                                isInputValueTrim_onChange
                            />

                            {/* Reference Code */}
                            {(func_validation.isStringEqual_caseInsensitive(role, "Dealer") ||
                            func_validation.isStringEqual_caseInsensitive(role, "Sales Person"))? (
                                <FormInput_text  
                                    inputLabel={"Reference Code"}

                                    className={"userUpdate-inputWrapper-referenceCode"}
                                    inputValue_default={referenceCode} 

                                    isInputBlurHandlingRequired
                                    handleInputBlurExtend={(value) => { setReferenceCode(value); }}

                                    inputMaxLength={200}

                                    customErrorMsgDefault={"Required"}
                                    isFormSubmissionAttempted={isFormSubmissionAttempted} 

                                    isMarginBtmOptional
                                />
                            ):""}
                        </div>


                        {/* Add User Group List */}
                        {userGroupDisplay}
                    </div>
                </React.Fragment>
            )}

            updateParentState_visiblity={props.updateParentState_visiblity}
        />
    );
}